export const Step = {
  INITAL: 1,
  CURRENCY: 2,
  FROM_ACCOUNT: 3,
  TO_ACCOUNT: 4,
  AMOUNT: 6,
  NOTE: 7,
  EXCHANGE_RATE: 8,
} as const;
